import { render, staticRenderFns } from "./Bildungsgangliste.vue?vue&type=template&id=f2f17ffa&"
import script from "./Bildungsgangliste.vue?vue&type=script&lang=js&"
export * from "./Bildungsgangliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports